// extracted by mini-css-extract-plugin
module.exports = {"file_thumb":"BriefingThumb_file_thumb__1Ku7o"};